import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset — please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail) || "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <PublicLayout>
      <div className="min-h-[calc(100vh-200px)] bg-[#F8F9FA] flex items-center justify-center py-16 px-6">
        <div className="w-full max-w-md">
          <div className="bg-white border border-slate-200 p-10 rounded-sm">
            <div className="label-overline text-[#E63946]">Password Reset</div>
            <h1 className="font-display text-4xl uppercase tracking-tighter mt-2">Set a New Password</h1>
            <p className="text-sm text-slate-600 mt-2">Choose a new password for your account.</p>

            {error && (
              <div data-testid="reset-error" className="mt-6 border-l-4 border-[#E63946] bg-red-50 p-3 text-sm text-[#E63946]">
                {error}
              </div>
            )}

            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <div>
                <label className="label-overline">New Password</label>
                <input
                  data-testid="reset-password-input"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-2 w-full px-4 py-3 border border-slate-300 rounded-sm focus:border-[#0A192F]"
                />
              </div>
              <div>
                <label className="label-overline">Confirm Password</label>
                <input
                  data-testid="reset-confirm-input"
                  type="password"
                  required
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="mt-2 w-full px-4 py-3 border border-slate-300 rounded-sm focus:border-[#0A192F]"
                />
              </div>
              <button
                data-testid="reset-submit-button"
                type="submit"
                disabled={busy}
                className="w-full bg-[#0A192F] hover:bg-[#1a2a4a] text-white py-3 text-sm font-semibold uppercase tracking-wider rounded-sm disabled:opacity-60"
              >
                {busy ? "Resetting…" : "Reset Password"}
              </button>
            </form>

            <div className="mt-6 text-center text-sm text-slate-600">
              <Link to="/login" className="text-[#E63946] font-semibold uppercase tracking-wider text-xs">
                Back to Sign In
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
